import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { environment } from 'projects/shared/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RuntimeConfigService {
  async loadActiveConfig() {
    for (const configUrl of this.activeConfigUrls()) {
      try {
        const response = await fetch(configUrl);
        if (!response.ok) continue;

        Object.assign(environment, await response.json());
      } catch {
        // Active config is optional and mirrors the existing admin web behavior.
      }
    }
  }

  private activeConfigUrls() {
    const commonConfigUrl = '/assets/active-config.json';
    const mobileConfigUrl = '/assets/admin-mobile-active-config.json';

    if (Capacitor.isNativePlatform() || !this.isLocalMobileHost()) {
      return [commonConfigUrl];
    }

    return [commonConfigUrl, mobileConfigUrl];
  }

  private isLocalMobileHost() {
    if (typeof location === 'undefined') return false;

    const host = location.hostname;
    return (
      host === 'localhost' ||
      host === '0.0.0.0' ||
      host === '::1' ||
      host.endsWith('.local') ||
      host.startsWith('127.') ||
      host.startsWith('10.') ||
      host.startsWith('192.168.') ||
      /^172\.(1[6-9]|2\d|3[0-1])\./.test(host)
    );
  }
}
